import {
	Box,
	Card,
	CardContent,
	CircularProgress,
	Grid,
	Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import HockeyPlannerRoot from "../../components/HockeyPlannerRoot";
import { createFrontendTrpcClient} from "../../utils";
import { useAuthStatus } from "../eventslist/hooks";
import UserOutstandingCard from "./UserOutstandingCard";

const trpcClient = createFrontendTrpcClient();

export default function OutstandingPaymentsView() {
	const { data: meData, error: meError } = useAuthStatus(() =>
		trpcClient.user.getOwn.query(),
	);

	const isManager = meData?.user?.is_manager ?? false;

	const { data: paymentStatus, isLoading } = useQuery({
		queryKey: ["payment-status-all-users"],
		queryFn: () => trpcClient.payment.getPaymentStatusForAllUsers.query(),
		enabled: !!meData && !meError && isManager,
	});

	if (!meData && !meError) {
		// still loading auth
		return (
			<HockeyPlannerRoot title="Ausstehende Zahlungen">
				<Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
					<CircularProgress />
				</Box>
			</HockeyPlannerRoot>
		);
	}

	if (!isManager) {
		return (
			<HockeyPlannerRoot title="Ausstehende Zahlungen">
				<Card sx={{ m: 2 }}>
					<CardContent>
						<Typography>Nur Manager können diese Ansicht sehen.</Typography>
					</CardContent>
				</Card>
			</HockeyPlannerRoot>
		);
	}

	if (isLoading) {
		return (
			<HockeyPlannerRoot title="Ausstehende Zahlungen">
				<Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
					<CircularProgress />
				</Box>
			</HockeyPlannerRoot>
		);
	}

	// Filter users that still owe money and sort by outstanding descending
	const owingUsers = (paymentStatus ?? [])
		.filter((u) => u.total_outstanding_cents > 0)
		.sort((a, b) => b.total_outstanding_cents - a.total_outstanding_cents);

	return (
		<HockeyPlannerRoot title="Ausstehende Zahlungen" showBackButton={true}>
			<Box sx={{ p: 2 }}>
				{owingUsers.length === 0 ? (
					<Card sx={{ m: 2 }}>
						<CardContent>
							<Typography>Keine offenen Zahlungen gefunden ✅</Typography>
						</CardContent>
					</Card>
				) : (
					<Grid container spacing={3}>
						{owingUsers.map((u) => (
							<Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={u.user_id}>
								<UserOutstandingCard user={u} />
							</Grid>
						))}
					</Grid>
				)}
			</Box>
		</HockeyPlannerRoot>
	);
}
